//
// Transition manager creates and manages transitions between containers

transitionManager = {};
transitionManager.currentTransitions = [];
transitionManager.transitionTypes = {};

transitionManager.initialise = function () {
  // Add default transitions
  transitionManager.addTransitionType(
    "CrossFade",
    transitionManager.CrossFadeInitialise,
    transitionManager.CrossFadeUpdate,
    transitionManager.CrossFadeComplete
  );
  transitionManager.addTransitionType(
    "SwipeDown",
    transitionManager.SwipeDownInitialise,
    transitionManager.SwipeDownUpdate,
    transitionManager.SwipeDownComplete
  );
  transitionManager.addTransitionType(
    "SwipeRight",
    transitionManager.SwipeRightInitialise,
    transitionManager.SwipeRightUpdate,
    transitionManager.SwipeRightComplete
  );
  transitionManager.addTransitionType(
    "Spiral",
    transitionManager.SpiralInitialise,
    transitionManager.SpiralUpdate,
    transitionManager.SpiralComplete
  );
};

transitionManager.addTransitionType = function (
  transitionType,
  initialiseFunction,
  updateFunction,
  completeFunction
) {
  if (
    typeof transitionManager.transitionTypes[transitionType] !== "undefined"
  ) {
    console.log("Transition type " + transitionType + " is already registered");
    return;
  }

  // Add new transition type
  transitionManager.transitionTypes[transitionType] = {
    type: transitionType,
    initialise: initialiseFunction,
    update: updateFunction,
    complete: completeFunction,
  };
};

transitionManager.startTransition = function (
  transitionType,
  inContainers,
  outContainers,
  completeCallback,
  time
) {
  if (
    typeof transitionManager.transitionTypes[transitionType] === "undefined"
  ) {
    console.log("Transition type " + transitionType + " was not found");
    return;
  }

  // If [in/out]containers is an array, use that array. If it's not defined, use blank array. Else use array with one object in.
  // This way we can handle all circumstances the same way
  var newTransition = {};
  newTransition.currentTime = 0;
  newTransition.totalTime = time | 1000;
  newTransition.completeCallback = completeCallback;
  newTransition.transitionType = transitionType;
  newTransition.inContainers = Array.isArray(inContainers)
    ? inContainers
    : typeof inContainers === "undefined"
    ? []
    : [inContainers];
  newTransition.outContainers = Array.isArray(outContainers)
    ? outContainers
    : typeof outContainers === "undefined"
    ? []
    : [outContainers];

  // Initialise
  transitionManager.initialiseTransition(newTransition);

  // Add to managed animations
  transitionManager.currentTransitions.push(newTransition);
};

transitionManager.initialiseTransition = function (transition) {
  var transitionDef =
    transitionManager.transitionTypes[transition.transitionType];

  // In containers
  for (var i = 0; i < transition.inContainers.length; i++) {
    transitionDef.initialise(transition.inContainers[i], true);
  }

  // Out containers
  for (var i = 0; i < transition.outContainers.length; i++) {
    transitionDef.initialise(transition.outContainers[i], false);
  }
};

transitionManager.updateTransition = function (transition) {
  var progress = transition.currentTime / transition.totalTime;
  var transitionDef =
    transitionManager.transitionTypes[transition.transitionType];

  // In containers
  for (var i = 0; i < transition.inContainers.length; i++) {
    transitionDef.update(transition.inContainers[i], true, progress);
  }

  // Out containers
  for (var i = 0; i < transition.outContainers.length; i++) {
    transitionDef.update(transition.outContainers[i], false, progress);
  }
};

transitionManager.completeTransition = function (transition) {
  var progress = transition.currentTime / transition.totalTime;
  var transitionDef =
    transitionManager.transitionTypes[transition.transitionType];

  // In containers
  for (var i = 0; i < transition.inContainers.length; i++) {
    transitionDef.complete(transition.inContainers[i], true, progress);
  }

  // Out containers
  for (var i = 0; i < transition.outContainers.length; i++) {
    transitionDef.complete(transition.outContainers[i], false, progress);
  }

  // Callback to say transition has complete
  if (transition.completeCallback !== undefined) {
    transition.completeCallback();
  }
};

transitionManager.onOrientationChange = function () {
  for (var i = 0; i < transitionManager.currentTransitions.length; i++) {
    transitionManager.updateTransition(transitionManager.currentTransitions[i]);
  }
};

transitionManager.update = function (delta, time) {
  for (var i = transitionManager.currentTransitions.length - 1; i >= 0; i--) {
    // Update progress
    transitionManager.currentTransitions[i].currentTime += delta;
    if (
      transitionManager.currentTransitions[i].currentTime >=
      transitionManager.currentTransitions[i].totalTime
    ) {
      // Transition has completed, so assert positions
      transitionManager.currentTransitions[i].currentTime =
        transitionManager.currentTransitions[i].totalTime;
      transitionManager.updateTransition(
        transitionManager.currentTransitions[i]
      );

      // Complete transition
      transitionManager.completeTransition(
        transitionManager.currentTransitions[i]
      );

      // Remove transition as it's now complete
      transitionManager.currentTransitions.splice(i, 1);
    } else {
      // Update transition
      transitionManager.updateTransition(
        transitionManager.currentTransitions[i]
      );
    }
  }
};

// ---------------------
// Cross fade
// ---------------------
transitionManager.CrossFadeInitialise = function (container, isIn) {
  container.alpha = isIn ? 0 : 1;
  container.visible = true;
};
transitionManager.CrossFadeUpdate = function (container, isIn, progress) {
  container.alpha = isIn ? progress : 1 - progress;
};
transitionManager.CrossFadeComplete = function (container, isIn, progress) {
  container.alpha = isIn ? 1 : 0;
};

// ---------------------
// Swipe Down
// ---------------------
transitionManager.SwipeDownInitialise = function (container, isIn) {
  var screenSize = resourceManager.getLogicalScreenSize();

  container.position.y = isIn ? -screenSize.height * Reflex.scaleY : 0;
  container.visible = true;
  container.alpha = isIn ? 0 : 1;
};
transitionManager.SwipeDownUpdate = function (container, isIn, progress) {
  var screenSize = resourceManager.getLogicalScreenSize();
  var position = Reflex.getContainerPosition(container.Props.ID).position;

  var lProgress = (Math.sin(Math.PI * progress + Math.PI * 1.5) + 1) / 2;

  container.position.y = isIn
    ? position.y - screenSize.height * (1 - lProgress) * Reflex.scaleY
    : position.y + screenSize.height * lProgress * Reflex.scaleY;
  container.alpha = isIn ? lProgress : 1 - lProgress;
};
transitionManager.SwipeDownComplete = function (container, isIn) {
  var screenSize = resourceManager.getLogicalScreenSize();
  var position = Reflex.getContainerPosition(container.Props.ID).position;

  container.position.y = isIn
    ? position.y
    : position.y + screenSize.height * Reflex.scaleY;
  container.alpha = isIn ? 1 : 0;
};

// ---------------------
// Swipe Right
// ---------------------
transitionManager.SwipeRightInitialise = function (container, isIn) {
  var screenSize = resourceManager.getLogicalScreenSize();

  container.position.x = isIn ? -screenSize.height * Reflex.scaleX : 0;
  container.visible = true;
  container.alpha = isIn ? 0 : 1;
};
transitionManager.SwipeRightUpdate = function (container, isIn, progress) {
  var screenSize = resourceManager.getLogicalScreenSize();
  var position = Reflex.getContainerPosition(container.Props.ID).position;

  var lProgress = (Math.sin(Math.PI * progress + Math.PI * 1.5) + 1) / 2;

  container.position.x = isIn
    ? position.x - screenSize.width * (1 - lProgress) * Reflex.scaleX
    : position.x + screenSize.width * lProgress * Reflex.scaleX;
  container.alpha = isIn ? lProgress : 1 - lProgress;
};
transitionManager.SwipeRightComplete = function (container, isIn, progress) {
  var screenSize = resourceManager.getLogicalScreenSize();
  var position = Reflex.getContainerPosition(container.Props.ID).position;

  container.position.x = isIn
    ? position.x
    : position.x + screenSize.height * Reflex.scaleX;
  container.alpha = isIn ? 1 : 0;
};

// ---------------------
// Spiral
// ---------------------
transitionManager.SpiralInitialise = function (container, isIn) {};
transitionManager.SpiralUpdate = function (container, isIn, progress) {};
transitionManager.SpiralComplete = function (container, isIn, progress) {};

Reflex.addToUpdate(transitionManager.update);
Reflex.registerInitialiseManager(transitionManager.initialise);
Reflex.registerEventHandler(
  "orientationChange",
  transitionManager.onOrientationChange
);
